export default "__VITE_ASSET__BULgt2K8__"